/* eslint-disable indent */
'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

import { getLabelTypography } from '@components/Common/Label';
import { InputFieldProps, InputIconProps } from '@components/Input/interfaces';

export const InputContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-width: 0;
`;
export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: ${Spacers.XS}rem;
`;

export const InputField = styled.input<InputFieldProps>`
  padding: ${Spacers.SM}rem ${Spacers.BASE}rem;
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  width: 100%;
  height: ${(props) => (props.$variant === 'schoolListing' ? '5.625rem' : '2.625rem')};
  background-color: ${(props) =>
    props.$backgroundColor ? `${props.$backgroundColor}` : props.theme.colors.backgroundAccent};
  border: ${(props) => (props.$hasError ? `1px solid ${props.theme.colors.statusError}` : 'none')};
  border-radius: ${Spacers.XS}rem;
  outline: none;
  padding-left: ${(props) => (props.$hasIcon ? `${Spacers.XL}rem` : 'none')};
  padding-right: ${(props) => (props.$isSearch ? `${Spacers.XL}rem` : 'none')};
  color: ${(props) =>
    props.$color
      ? `${props.$color}`
      : props.$hasError
        ? props.theme.colors.statusError
        : props.theme.colors.typographyBodyLight};

  &::placeholder {
    color: ${(props) =>
      props.$color
        ? `${props.$color}`
        : props.$hasError
          ? props.theme.colors.statusError
          : props.theme.colors.typographyBodyLight};
    ${(props) =>
      props.$variant === 'schoolListing' &&
      `
      position: absolute;
      top: ${Spacers.SM}rem;
      transform: translateY(0);
      transition: all 0.2s ease;
    `}
  }

  &:focus {
    color: ${(props) =>
      props.$color
        ? `${props.$color}`
        : props.$hasError
          ? props.theme.colors.statusError
          : props.theme.colors.typographyHeadersLight};
  }

  /* Remove the default clear button in search inputs */
  &::-webkit-search-cancel-button {
    -webkit-appearance: none;
    appearance: none;
    display: none;
  }

  /* For Firefox */
  &::-moz-search-clear {
    display: none;
  }
`;

export const ErrorLabel = styled.strong`
  ${getLabelTypography}
  color: ${(props) => props.theme.colors.statusError};
  margin-left: auto;
  margin-bottom: ${Spacers.XS}rem;
`;

export const IconWrapper = styled.div<InputIconProps>`
  position: absolute;
  top: 50%;
  ${(props) =>
    props.position === 'left' ? `left: ${Spacers.BASE}rem;` : `right: ${Spacers.BASE}rem;`}
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) =>
    props.$isFocused
      ? props.theme.colors.typographyHeadersLight
      : props.theme.colors.typographyBodyLight};
`;
